/* eslint-ignore */
// @ts-nocheck
import { Form, Formik } from 'formik';
import React, { Component } from 'react';
import { Form as BootstrapForm } from 'react-bootstrap';
import { IoMdArrowBack, IoMdPersonAdd } from 'react-icons/io';
import { MdLockOutline } from 'react-icons/md';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { ReactComponent as IconFormUser } from '~/assets/icons/form-user.svg';
import { ReactComponent as IconReceipt } from '~/assets/icons/receipt.svg';
import ContainedButton from '~/components/layout/form/containedButton';
import OutlinedButton from '~/components/layout/form/outlinedButton';
import TextField from '~/components/layout/form/textField';
import api from '~/services/api';
import {
  registerContactName,
  toggleStep,
} from '~/store/actions/singup-actions';
import { FormBox } from './styles';

const regex =
  /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])(?=.{8,})/;

class SignupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showPassword: false,
    };
  }

  SignUpSchema = () =>
    Yup.object().shape({
      lastInvoiceNumber: Yup.number().required(
        'Digite o número da nota fiscal'
      ),
      penultimateInvoiceNumber: Yup.number().required(
        'Digite o número da outra nota fiscal'
      ),
      email: Yup.string()
        .required('Insira um e-mail válido')
        .email('Complete o campo com um e-mail válido'),
      password: Yup.string()
        .required('Insira uma senha')
        .matches(
          regex,
          'Use oito ou mais caracteres com uma combinação de letras, números e símbolos'
        ),
      passwordConfirmation: Yup.string()
        .required('Insira a confirmação de sua senha')
        .oneOf([Yup.ref('password'), null], 'As senhas não combinam'),
    });

  // Primeira requisição
  requestRegisterEmail = async (values) => {
    this.setState({ loading: true });
    const { siteId, userId } = this.props;
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };

    const body = {
      contact: values.email,
      contactType: 'EMAIL',
      contactValidation: {
        lastInvoiceNumber: values.lastInvoiceNumber,
        penultimateInvoiceNumber: values.penultimateInvoiceNumber,
      },
      siteId,
    };

    if (!siteId) {
      toast.error('Não conseguimos identificar seu endereço!');
    }

    api
      .post(`industrial/customer/v1/users/${userId}/contacts`, body, parameters)
      .then((res) => {
        if (res.status === 201) {
          const contactId = res.headers.location.split('/').pop();
          if (contactId) {
            this.props.dispatch(registerContactName(values.email, contactId));
            this.requestRegisterPassword(values);
          } else {
            this.setState({ loading: false });
            toast.error('Não foi possível cadastrar este e-mail!');
          }
        } else {
          this.setState({ loading: false });
          toast.error('Não foi possível cadastrar este e-mail!');
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  // Segunda requisição
  requestRegisterPassword = (values) => {
    const { contactId, userId, url } = this.props;
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      contactId,
      password: values.password,
      passwordConfirmation: values.passwordConfirmation,
    };
    api
      .post(
        `industrial/customer/v1/users/${userId}/passwords`,
        body,
        parameters
      )
      .then((res) => {
        this.setState({ loading: false });
        this.sendValidationToken(contactId, userId, url);
      })
      .catch((err) => {
        this.setState({ loading: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  sendValidationToken = (contactId, userId, url) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      tokenType: 'REGISTER',
      url: process.env.REACT_APP_REGISTER_URL_CONFIRMATION,
      contactId,
    };
    api
      .post(`industrial/customer/v1/users/${userId}/tokens`, body, parameters)
      .then((res) => {
        this.props.dispatch(toggleStep(5));
      })
      .catch((err) => {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          toast.error(message);
        } else {
          toast.error('Ocorreu um erro interno na aplicação');
          toast.error(
            'Certifique-se de estar conectado a internet ou tente novamente mais tarde!'
          );
        }
      });
  };

  handlePassVisibility() {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  }

  handleInvoice = (e, handleChange) => {
    const event = e;
    const numbers = event.target.value.replace(/[^\d]/g, '');
    event.target.value = numbers;
    handleChange(event);
  };

  render() {
    return (
      <FormBox>
        <Formik
          initialValues={{
            lastInvoiceNumber: this.props.lastInvoiceNumber || '',
            penultimateInvoiceNumber: this.props.penultimateInvoiceNumber || '',
            email: this.props.newEmail || '',
            password: '',
            confirmPassword: '',
          }}
          onSubmit={(values) => {
            this.requestRegisterEmail(values);
          }}
          validationSchema={this.SignUpSchema}
          render={({ handleChange, handleBlur, values, errors, touched }) => (
            <Form>
              <p>
                Por favor insira o número de 2 notas fiscais diferentes,
                emitidas em até 2 anos.
              </p>
              <BootstrapForm.Group controlId="lastInvoiceNumber">
                <TextField
                  id="lastInvoiceNumber"
                  type="text"
                  ariaLabel="Digite o número da nota fiscal"
                  ariaRequired
                  errorCondition={
                    errors.lastInvoiceNumber && touched.lastInvoiceNumber
                  }
                  errorMessage={errors.lastInvoiceNumber}
                  title="Digite o número da nota fiscal"
                  onBlur={handleBlur}
                  placeholder="Digite o número da nota fiscal"
                  label="Digite o número da nota fiscal"
                  value={values.lastInvoiceNumber}
                  onChange={(e) => {
                    this.handleInvoice(e, handleChange);
                  }}
                  LeadingIcon={() => <IconReceipt />}
                />
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId="penultimateInvoiceNumber">
                <TextField
                  id="penultimateInvoiceNumber"
                  type="text"
                  ariaLabel="Digite o número da outra nota fiscal"
                  ariaRequired
                  errorCondition={
                    errors.penultimateInvoiceNumber &&
                    touched.penultimateInvoiceNumber
                  }
                  errorMessage={errors.penultimateInvoiceNumber}
                  title="Digite o número da outra nota fiscal"
                  onBlur={handleBlur}
                  placeholder="Digite o número da outra nota fiscal"
                  label="Digite o número da outra nota fiscal"
                  value={values.penultimateInvoiceNumber}
                  onChange={(e) => {
                    this.handleInvoice(e, handleChange);
                  }}
                  LeadingIcon={() => <IconReceipt />}
                />
              </BootstrapForm.Group>
              <div
                className="d-flex justify-content-center w-100 mb-4"
                style={{ marginTop: 10 }}
              >
                <a
                  className="terms"
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.props.dispatch(toggleStep(4.1))}
                >
                  <span>Não possuo as Notas Fiscais</span>
                </a>
              </div>
              <BootstrapForm.Group controlId="email">
                <TextField
                  id="email"
                  type="text"
                  title="Seu e-mail"
                  placeholder="E-mail"
                  label="Seu e-mail"
                  ariaLabel="Seu e-mail"
                  ariaRequired
                  errorCondition={errors.email && touched.email}
                  errorMessage={errors.email}
                  onBlur={handleBlur}
                  value={values.email}
                  onChange={handleChange}
                  LeadingIcon={() => <IconFormUser />}
                />
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId="password">
                <TextField
                  id="password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  title="Sua senha"
                  placeholder="Senha"
                  label="Senha"
                  ariaLabel="Senha"
                  ariaRequired
                  errorCondition={errors.password && touched.password}
                  errorMessage={errors.password}
                  onBlur={handleBlur}
                  value={values.password}
                  onChange={handleChange}
                  showChangeTextPassword="true"
                  LeadingIcon={() => <MdLockOutline size={25} />}
                />
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId="passwordConfirmation">
                <TextField
                  id="passwordConfirmation"
                  type="password"
                  label="Confirmação de Senha"
                  ariaLabel="Confirmação de Senha"
                  ariaRequired
                  errorCondition={
                    errors.passwordConfirmation && touched.passwordConfirmation
                  }
                  errorMessage={errors.passwordConfirmation}
                  title="Confirmação de Senha"
                  onBlur={handleBlur}
                  placeholder="Confirme a senha"
                  value={values.passwordConfirmation}
                  onChange={handleChange}
                  showChangeTextPassword="true"
                  LeadingIcon={() => <MdLockOutline size={25} />}
                />
              </BootstrapForm.Group>
              <div style={{ marginTop: 50 }}>
                <ContainedButton
                  className="mb-2"
                  block
                  type="submit"
                  icon="account-plus"
                  text="Confirmar"
                  color="#288efd"
                  loading={this.state.loading}
                  name="confirmar"
                  id="confirmar"
                  width="100%"
                  TrailingIcon={() => <IoMdPersonAdd size={20} />}
                >
                  Confirmar
                </ContainedButton>
                <OutlinedButton
                  onClick={() => this.props.dispatch(toggleStep(3))}
                  className="mb-2"
                  block
                  outline
                  text="Voltar"
                  color="#76d2e1"
                  name="Voltar"
                  id="Voltar"
                  width="100%"
                  LeadingIcon={() => <IoMdArrowBack size={20} />}
                >
                  Voltar
                </OutlinedButton>
              </div>
            </Form>
          )}
        />
      </FormBox>
    );
  }
}

const mapStateToProps = (state) => ({
  lastInvoiceNumber: state.signUpReducer.lastInvoiceNumber,
  penultimateInvoiceNumber: state.signUpReducer.penultimateInvoiceNumber,
  newEmail: state.signUpReducer.newEmail,
  contactName: state.signUpReducer.contactName,
  siteId: state.signUpReducer.siteId,
  userId: state.signUpReducer.userId,
  contactId: state.signUpReducer.contactId,
  url: state.signUpReducer.url,
});

export default connect(mapStateToProps)(SignupComponent);
